"use strict";
$('.breadcrumbs').each(function () {
    if (this.scrollWidth > this.clientWidth) {
        $('.breadcrumbsMobileOverlay').show();
    }
});
$('.breadcrumbs').scroll(function () {
    if (this.scrollLeft > this.scrollWidth - this.clientWidth - 26) {
        $('.breadcrumbsMobileOverlay').fadeOut("slow");
    }
    else {
        $('.breadcrumbsMobileOverlay').fadeIn("slow");
    }
});
